import { render, staticRenderFns } from "./VacanciesManagement.vue?vue&type=template&id=01937624&scoped=true&"
import script from "./VacanciesManagement.vue?vue&type=script&lang=js&"
export * from "./VacanciesManagement.vue?vue&type=script&lang=js&"
import style0 from "./VacanciesManagement.vue?vue&type=style&index=0&id=01937624&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01937624",
  null
  
)

export default component.exports